/** A hole opens only after the device misses its own link interval. */
export const SCHEDULE_GAP_FACTOR = 1.5;

export function withScheduleGaps(points, periodSeconds, emptyFields) {
  const periodMs = Number(periodSeconds) * 1000;
  const limit = Number.isFinite(periodMs) && periodMs > 0 ? periodMs * SCHEDULE_GAP_FACTOR : null;
  const result = [];

  for (const point of points || []) {
    const bucketMs = Date.parse(point.bucket_at);
    const previous = result[result.length - 1];
    if (
      limit &&
      previous &&
      !previous.is_gap &&
      Number.isFinite(bucketMs) &&
      Number.isFinite(previous.bucket_ms) &&
      bucketMs - previous.bucket_ms > limit
    ) {
      result.push({
        bucket_at: new Date(previous.bucket_ms + periodMs).toISOString(),
        bucket_ms: previous.bucket_ms + periodMs,
        is_gap: true,
        ...emptyFields,
      });
    }
    result.push({ ...point, bucket_ms: bucketMs });
  }

  return result;
}
